import { PackageFragment } from "@pathwright/graphql-client/src/generated"
import {
  PackageColorMode,
  PackageThemeOverrides,
  ResolvedPackageTheme
} from "./types"

const darkBGColor = "rgb(34, 32, 32)"
const textOnDarkBGColor = "rgb(255, 246, 241)"
const secondaryTextOnDarkBGColor = "rgb(148, 140, 136)"
const lightBGColor = "var(--chakra-colors-white)"
const textOnLightBGColor = "var(--chakra-colors-gray-900)"
const secondaryTextOnLightBGColor = "var(--chakra-colors-gray-600)"

const getBaseTheme = (colorMode?: PackageColorMode): ResolvedPackageTheme => {
  if (colorMode === "light") {
    return {
      primaryColor: "var(--school-main-color)",
      backgroundColor: lightBGColor,
      textColor: textOnLightBGColor,
      secondaryTextColor: secondaryTextOnLightBGColor
    }
  }

  return {
    primaryColor: "var(--school-main-color)",
    backgroundColor: darkBGColor,
    textColor: textOnDarkBGColor,
    secondaryTextColor: secondaryTextOnDarkBGColor
  }
}

export const getResolvedPackageTheme = ({
  packageData,
  themeOverrides,
  colorMode
}: {
  packageData?: PackageFragment | null
  themeOverrides?: PackageThemeOverrides
  colorMode?: PackageColorMode
}): ResolvedPackageTheme => {
  const baseTheme = getBaseTheme(colorMode)
  const packageAccentColor = packageData?.color
    ? `#${packageData.color}`
    : undefined

  return {
    ...baseTheme,
    primaryColor:
      themeOverrides?.primaryColor ||
      packageAccentColor ||
      baseTheme.primaryColor,
    backgroundColor:
      themeOverrides?.backgroundColor || baseTheme.backgroundColor
  }
}
